import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from './locales/en.json'
import deTranslation from './locales/de.json'
import frTranslation from './locales/fr.json'
import { MRT_Localization } from 'material-react-table'
import { MRT_Localization_DE } from 'material-react-table/locales/de'
import { MRT_Localization_EN } from 'material-react-table/locales/en'
import LanguageDetector from 'i18next-browser-languagedetector'

export const resources = {
  de: {
    translation: deTranslation,
  },
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'de',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    debug: false,
  })

/**
 * Get the mrt locale
 * @returns the mrt locale
 */
export function getMRTLocale(): MRT_Localization | undefined {
  if (i18n.language == 'de') {
    return MRT_Localization_DE
  } else if (i18n.language == 'en') {
    return MRT_Localization_EN
  }
  return undefined
}

export default i18n
